// @flow

import React from 'react';
import { useHistory } from 'react-router-dom';

import { useDeleteNativeInferencePoolMutation } from '../../../service-definitions/estimates';
import { useEstimateId } from '../../../custom-hooks/useEstimateId';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';
import { getLinkForEstimate } from '../../links/utils';
import { ConfirmModal } from '../../presentational/modals/ConfirmModal';
import { toastError, toastSuccess } from '../../presentational/notifications/utils';

export const NativeInferencePoolDeleteWarningModal = ({
  isOpen,
  setOpen,
  nativeInferencePoolId,
  poolName,
}) => {
  const [deleteNativeInferencePool] = useDeleteNativeInferencePoolMutation();
  const estimateId = useEstimateId();
  const estimateVersion = useEstimateVersion();
  const { push } = useHistory();

  const header = `Delete Inference Pool ${poolName}`;
  const body = <p>Are you sure you want to delete this Inference Pool?</p>;

  const onClickYesHandler = async () => {
    const { error } = await deleteNativeInferencePool({
      estimateId,
      nativeInferencePoolId,
      payload: {
        estimate_id: estimateId,
        id: nativeInferencePoolId,
        estimate_version: estimateVersion,
      },
    });

    if (error) {
      toastError(error);
    } else {
      toastSuccess('Successfully deleted the Inference Pool!');
      push(getLinkForEstimate(estimateId));
    }
  };

  return (
    <ConfirmModal
      body={body}
      header={header}
      isOpen={isOpen}
      onClickHandlerForCancel={() => setOpen(false)}
      onClickHandlerForOK={onClickYesHandler}
    />
  );
};

export default NativeInferencePoolDeleteWarningModal;
